import logoExample from "@/assets/branding/logo-example.svg";

/** Max logo image bounds per size (px). Width caps wide logos; height fits navbar. */
export const LOGO_IMAGE_BOUNDS = {
  sm: { maxHeight: 32, maxWidth: 128 },
  md: { maxHeight: 40, maxWidth: 168 },
  lg: { maxHeight: 48, maxWidth: 208 },
};

export const LOGO_TEXT = "عقارات الكويت";

/** Example horizontal logo — replace via VUE_APP_LOGO_IMAGE or AppLogo `src` prop. */
export const LOGO_IMAGE_EXAMPLE = logoExample;

export function resolveLogoImageSrc(src) {
  return src || process.env.VUE_APP_LOGO_IMAGE || LOGO_IMAGE_EXAMPLE;
}

export function getLogoImageBounds(size = "md") {
  return LOGO_IMAGE_BOUNDS[size] ?? LOGO_IMAGE_BOUNDS.md;
}
